import { Component } from "react"
import { Button, Card, CardContent } from "@mui/material"
import "./style.scss"

function logout() {
  window.location = "/logout"
}

class AccountNotActivated extends Component {
  render() {
    return <div className="modules_account-not-activated">
      <Card className="content-wrapper" elevation={0} square>
        <CardContent className="not-activated">
          <div className="title">Contact your admin</div>
          <div className="text">
            This account hasn&apos;t been activated yet. Please contact the administrator.
          </div>
          <Button color="primary" variant="contained" size="large" onClick={logout}>
            Logout
          </Button>
        </CardContent>
      </Card>
    </div>
  }
}

export default AccountNotActivated
